import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';
import type { AutoplayButtonProps } from '../base/AutoplayButton';
import { AutoplayButton } from '../base/AutoplayButton';

import styles from './AutoplayModifyButton.module.css';

export interface AutoplayModifyButtonProps extends AutoplayButtonProps {
  addOn: number;
  totalBet: ReactElement | string;
}

export const AutoplayModifyButton: FC<AutoplayModifyButtonProps> = ({ addOn, totalBet, className, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayModifyBtn', {}, { withBaseClass: true, extraClassName: className });
  return (
    <AutoplayButton className={mods} {...rest}>
      <div data-testid="autoplay-modify-button" className={styles.autoplayModifyBtn__info}>
        <span data-testid={`autoplay-modify-addon-${addOn}`} className={styles.autoplayModifyBtn__addOn}>
          {'+'}
          {addOn}
        </span>
        <span className={styles.autoplayModifyBtn__roundText}>
          <L10nText tk="ROUNDS" />
        </span>
      </div>
      <span data-testid="autoplay-modify-total-bet" className={styles.autoplayModifyBtn__totalBet}>{totalBet}</span>
    </AutoplayButton>
  );
};
